import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface InsuranceHeroProps {
  title: string;
  description: string;
  jsonLd: Record<string, any>;
}

export const InsuranceHero = ({ title, description, jsonLd }: InsuranceHeroProps) => {
  return (
    <section className="py-12 px-4 bg-gradient-to-b from-white to-purple-50">
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 animate-fade-up">
          <h1 className="text-4xl md:text-5xl font-bold text-primary-dark mb-6">
            {title}
          </h1>
          <p className="text-lg text-neutral max-w-2xl mx-auto">
            {description}
          </p>
        </div>
        <div className="text-center animate-fade-up">
          <Link to="/quote">
            <Button size="lg" className="bg-primary hover:bg-primary/90">
              Quick Quote
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};